import styled from 'styled-components';

import { Cloud } from 'app/theme/Icons/Cloud';
import { fileUploader } from 'app/translations/dictionary';

const CloudImage = styled(Cloud)`
  display: block;
  margin: 0 auto;
  flex-grow: 1;
  max-height: 8rem;
`;

const Header = styled.div`
  text-align: center;
  font-size: 2.5rem;
  font-weight: bold;
  margin: 0;
  padding: 0;
`;

export const FileUploaderHeader = (): JSX.Element => (
  <>
    <CloudImage />
    <Header>{fileUploader.title}</Header>
  </>
);
